import { TAG_BIND_MODE } from './constants'

/**
 * Med: 预览 diff 与入库 finalState 必须严格对齐。
 * 后端对应实现：wallpaper-app/.../TagBatchBindExe.java#computeFinalTagKeys。
 * 修改这里的算法时，必须同步修改后端；
 * 否则会出现「预览显示正常,实际入库结果不一致」的隐藏风险。
 */
function toNameList(tagList = []) {
  return tagList.map((tag) => (typeof tag === 'string' ? tag : tag.name)).filter(Boolean)
}

function mergeTagNames(existingNames = [], inputNames = [], mode) {
  const existing = [...existingNames]
  // Med: 与后端 TagBatchBindExe#toTagKeySet 对齐,对 input 做 trim,
  // 避免用户输入「 Kpop 」(带空格)时预览显示带空格但后端落库已 trim,
  // 导致用户感知的「已选」与实际入库不一致。
  const input = inputNames
    .map((name) => (typeof name === 'string' ? name : name?.name))
    .filter(Boolean)
    .map((name) => String(name).trim())
    .filter((name) => name.length > 0)
  if (mode === TAG_BIND_MODE.REPLACE) {
    return input
  }
  if (mode === TAG_BIND_MODE.REMOVE) {
    return existing.filter((name) => !input.includes(name))
  }
  const merged = new Set([...existing, ...input])
  return Array.from(merged)
}

/** 计算 Tag diff，供预览弹窗展示增删保留。 */
function computeTagDiff(beforeNames = [], afterNames = []) {
  const beforeSet = new Set(beforeNames)
  const afterSet = new Set(afterNames)
  const keptTags = beforeNames.filter((name) => afterSet.has(name))
  const addedTags = afterNames.filter((name) => !beforeSet.has(name))
  const removedTags = beforeNames.filter((name) => !afterSet.has(name))
  const hasChange = addedTags.length > 0 || removedTags.length > 0
  return { keptTags, addedTags, removedTags, hasChange }
}

/**
 * 构建页面打标 / Excel 打标共用的预览行（含 diff 字段；界面不展示 key）。
 */
export function buildPreviewRows({ items, existingTagMap = {}, mode, selectedTagNames = [] }) {
  return items.map((item) => {
    const resourceKey = item.resourceKey || item.key
    const beforeTags = existingTagMap[resourceKey] || []
    const beforeNames = toNameList(beforeTags)
    const inputNames = item.tagNames || selectedTagNames || []
    const afterNames = mergeTagNames(beforeNames, inputNames, mode)
    const diff = computeTagDiff(beforeNames, afterNames)

    return {
      title: item.title || item.resourceName || item.wallpaperName || '',
      resourceType: item.resourceType || item.assetType || item.wallpaperType || '',
      resourceKey,
      keptTags: diff.keptTags,
      addedTags: diff.addedTags,
      removedTags: diff.removedTags,
      hasChange: diff.hasChange,
      willClear: mode === TAG_BIND_MODE.REPLACE && inputNames.length === 0,
    }
  })
}

export function collectClearWarnings(previewRows = []) {
  return previewRows.filter((row) => row.willClear)
}
